import {Button} from 'shells/button/button';
import {IconOnlyButton} from 'shells/button/icon-only-button/icon-only-button';
import {BranchRegularIcon} from 'shells/icon/svg/branch-regular-icon';
import {TrashRegularIcon} from 'shells/icon/svg/trash-regular-icon';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {SidebarState} from '../../sidebar/sidebar';

interface Props {
    setSidebarState: (sidebarState: SidebarState) => void;
    pageIndex: number;
    onRemovePage: (pageIndex: number) => void;
    setActivePageIndex: (pageIndex: number | null | undefined) => void;
}

export function PageFooter(props: Props) {
    const handleConfigureClick = () => {
        props.setSidebarState('branching-rules');
        props.setActivePageIndex(props.pageIndex);
    };

    return (
        <Stack isHorizontal={true} justifyContent='space-between' alignItems='center'>
            <Body color='light' size='small'>
                Page {props.pageIndex + 1}
            </Body>
            <Stack isHorizontal={true} justifyContent='end' alignItems='center' spacing={16}>
                <Button
                    variant='text-secondary-dark'
                    size='small'
                    onClick={handleConfigureClick}
                    noPadding={true}
                >
                    <Stack isHorizontal={true} justifyContent='end' alignItems='center' spacing={8}>
                        <BranchRegularIcon size={16} wrapWithDiv={false} />
                        Configure branching
                    </Stack>
                </Button>
                <IconOnlyButton
                    icon={TrashRegularIcon}
                    tooltipText='Remove page'
                    onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => {
                        e.stopPropagation();
                        props.onRemovePage(props.pageIndex);
                    }}
                />
            </Stack>
        </Stack>
    );
}
